// Generated by tools/generate-version.mjs. Do not edit.
export const APP_VERSION = '3.2.35';
